import React from 'react';
import { formatAmount } from '../../Utils/billingoDocuments';

/**
 * What a document charges. A final Számla nets off the advances it deducts,
 * so its `total` is less than the order value — the deduction is named under
 * it ("− €120.00 advance") so the two reconcile at a glance. Documents from an
 * API that does not report `advance_deducted` show their total alone.
 * `className` styles the amount only (e.g. the details modal's large figure).
 */
function DocumentTotal({ doc, className = '' }) {
  const advance = Number(doc.advance_deducted) || 0;
  return (
    <>
      <span className={className}>{formatAmount(doc.total, doc.currency)}</span>
      {advance > 0 && (
        <div className="text-muted small text-nowrap">
          {`− ${formatAmount(advance, doc.currency)} advance`}
        </div>
      )}
    </>
  );
}

export default DocumentTotal;
